import { withAuthenticator } from "@aws-amplify/ui-react";

const formFields = {
  signIn: {
    username: {
      dialCode: "+81",
    },
  },
  signUp: {
    phone_number: {
      dialCode: "+81",
    },
  },
};

export default function withAuth(element) {
  return withAuthenticator(element, {
    loginMechanisms: ["phone_number"],
    signUpAttributes: ["phone_number"],
    socialProviders: ["google"],
    formFields: formFields,
  });
}
